const ATTR_ARIA_EXPANDED = 'aria-expanded';

const initProductShare = () => {
  const shareBlocks = document.querySelectorAll('[data-product-share]');
  if (!shareBlocks.length) return;

  const popupFeatures = 'width=600,height=600,menubar=no,toolbar=no,status=no';
  const successMessageTimeout = 2000;

  shareBlocks.forEach((block) => {
    const toggle = block.querySelector('[data-product-share-toggle]');
    const panel = block.querySelector('[data-product-share-panel]');
    const copyButton = block.querySelector('[data-share-copy-link]');
    const successMessage = block.querySelector('[data-share-copy-success]');

    const closePanel = () => {
      panel?.classList.add('hidden');
      toggle?.setAttribute(ATTR_ARIA_EXPANDED, 'false');
    };

    const openPanel = () => {
      panel?.classList.remove('hidden');
      toggle?.setAttribute(ATTR_ARIA_EXPANDED, 'true');
    };

    toggle?.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = toggle.getAttribute(ATTR_ARIA_EXPANDED) === 'true';
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    });

    document.addEventListener('click', (event) => {
      if (!block.contains(event.target)) {
        closePanel();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePanel();
      }
    });

    block.querySelectorAll('[data-share-facebook], [data-share-x]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const shareLink = link.getAttribute('href');
        if (!shareLink) return;
        window.open(shareLink, '_blank', popupFeatures);
      });
    });

    copyButton?.addEventListener('click', async () => {
      const url = window.location.href;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          const tempInput = document.createElement('input');
          tempInput.value = url;
          document.body.append(tempInput);
          tempInput.select();
          document.execCommand('copy');
          tempInput.remove();
        }

        if (successMessage) {
          successMessage.classList.remove('hidden');
          window.setTimeout(() => successMessage.classList.add('hidden'), successMessageTimeout);
        }
      } catch (error) {
        console.error('Failed to copy product link.', error);
      }
    });
  });
};

export default initProductShare;
